<div>
  <!-- Botón de cerrar en la esquina superior izquierda -->
  <button rel="tooltip" type="button" class="btn btn-action float-right close-button " (click)="closePopUp()">
    <i class="material-icons">close</i>
  </button>


  <div>
    <app-generic-panel [title]="'¿Cómo quieres descargar el listado?'" [description]="''"
      [awesomeIcon]="'file-download'">

      <div class="row justify-content-around">
        <!-- <div class=" mt-5">

          <dx-check-box (onValueChanged)="changeLocalHour($event)" [(value)]="localHour"
            text="Descargar con hora local">
          </dx-check-box>

        </div> -->
        <div class=" mt-5">
          <dx-check-box (onValueChanged)="changeDisabled($event)" [(value)]="disabled"
            text="Descargar con marcajes deshabilitados"></dx-check-box>
        </div>
      </div>

      <!-- Botonera -->
      <div class="row mt-2">
        <label class="col-md-3"></label>
        <div class="col-md-9">
          <div class="form-group form-button">
            <button class="btn btn-fill btn-primary float-right" type="button"
              (click)="downloadFile()">Descargar</button>
            <a class="btn btn-fill btn-outline-white float-right" (click)="closePopUp()">Cancelar</a>
          </div>
        </div>
      </div>
    </app-generic-panel>
  </div>




</div>